import { jsx as _jsx } from "react/jsx-runtime";
import { CustomFieldTypeName } from "@air/api/types";
import { parseAirDateToISO } from "@air/utilities";
import { format } from "__barrel_optimize__?names=format!=!date-fns";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { CustomFieldListWithOverflow } from "~/components/CustomFields/CustomFieldListWithOverflow";
import Linkify from "~/components/Linkify";
import { TABLE_CELL_H_PADDING } from "~/components/TableView/ui";
import { TABLE_CUSTOM_FIELD_CELL_BUTTON } from "~/constants/testIDs";
import { visibleCustomFieldsViewOptionsSelector } from "~/store/configViews/selectors";
import { EditableTableCell } from "../../EditableTableCell/EditableTableCell";
import { makeActiveTableColumnFromOption } from "../../tableColumnWidthsUtils";
import { useTableView } from "../../TableViewContext";
import { getTableColumnWidth } from "../../types";
import { getAdditionalPopperOffset } from "./utils";
export const BaseCustomFieldTableCell = (param)=>{
    let { customField, customFieldName, customFieldId, assignedCustomFieldValue, renderEditableCustomField } = param;
    const { getColumnWidthStyle } = useTableView();
    const visibleCustomFields = useSelector(visibleCustomFieldsViewOptionsSelector);
    const customFields = useMemo(()=>assignedCustomFieldValue ? [
            assignedCustomFieldValue
        ].filter((param)=>{
            let { id } = param;
            return visibleCustomFields.find((vcf)=>vcf.customFieldId === id);
        }) : [], [
        assignedCustomFieldValue,
        visibleCustomFields
    ]);
    const shouldRenderValue = useMemo(()=>{
        var _assignedCustomFieldValue_values;
        return !!(assignedCustomFieldValue === null || assignedCustomFieldValue === void 0 ? void 0 : assignedCustomFieldValue.dateValue) || !!(assignedCustomFieldValue === null || assignedCustomFieldValue === void 0 ? void 0 : assignedCustomFieldValue.plainTextValue) || !!(assignedCustomFieldValue === null || assignedCustomFieldValue === void 0 ? void 0 : assignedCustomFieldValue.value) || !!(assignedCustomFieldValue === null || assignedCustomFieldValue === void 0 ? void 0 : (_assignedCustomFieldValue_values = assignedCustomFieldValue.values) === null || _assignedCustomFieldValue_values === void 0 ? void 0 : _assignedCustomFieldValue_values.length);
    }, [
        assignedCustomFieldValue
    ]);
    const renderValue = useCallback((openEditor)=>{
        if (!assignedCustomFieldValue) return null;
        switch(assignedCustomFieldValue.type.title){
            case CustomFieldTypeName.singleSelect:
            case CustomFieldTypeName.multiSelect:
                {
                    return /*#__PURE__*/ _jsx(CustomFieldListWithOverflow, {
                        className: "p-1",
                        onClick: openEditor,
                        customFields: customFields,
                        allowedWidth: getTableColumnWidth("customField") - TABLE_CELL_H_PADDING * 2,
                        "data-testid": "".concat(TABLE_CUSTOM_FIELD_CELL_BUTTON, "-").concat(customFieldName)
                    });
                }
            case CustomFieldTypeName.plainText:
                {
                    return /*#__PURE__*/ _jsx("button", {
                        className: "h-5 w-full truncate text-left",
                        "data-testid": "TABLE_CELL_CUSTOM_FIELD_PLAIN_TEXT",
                        onClick: openEditor,
                        children: /*#__PURE__*/ _jsx(Linkify, {
                            children: assignedCustomFieldValue.plainTextValue || ""
                        })
                    });
                }
            case CustomFieldTypeName.date:
                {
                    const dateText = assignedCustomFieldValue.dateValue ? format(parseAirDateToISO(assignedCustomFieldValue.dateValue), "MMM dd, yyyy") : "";
                    return /*#__PURE__*/ _jsx("button", {
                        className: "h-5 w-full text-left",
                        onClick: openEditor,
                        children: dateText
                    });
                }
        }
    }, [
        customFields,
        customFieldName,
        assignedCustomFieldValue
    ]);
    const additionalPopperOffset = useMemo(()=>getAdditionalPopperOffset(customField, assignedCustomFieldValue), [
        customField,
        assignedCustomFieldValue
    ]);
    const tableCellStyle = useMemo(()=>getColumnWidthStyle(makeActiveTableColumnFromOption(customFieldName, true, customFieldId)), [
        getColumnWidthStyle,
        customFieldName,
        customFieldId
    ]);
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        columnWidth: getTableColumnWidth("customField"),
        "data-testid": "".concat(TABLE_CUSTOM_FIELD_CELL_BUTTON, "-").concat(customFieldName),
        renderValue: shouldRenderValue && renderValue,
        renderEditor: renderEditableCustomField,
        additionalPopperOffset: additionalPopperOffset,
        tableCellStyle: tableCellStyle
    });
};
